import * as React from "react"

import { Action } from "@tenforce/toolbox-button-push-react"
import { Modal } from "@tenforce/toolbox-modal-react"

import HierarchyItem from "./HierarchyItem"
import { Symbols } from "@tenforce/toolbox-fontmap"
import { IBreadcrumbInfo } from "../../index"

interface Props {
    sortedBreadcrumbs: IBreadcrumbInfo[]
}

interface State {
    show: boolean
}

export default class HierarchyPopup extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            show: false,
        }
    }

    render(): JSX.Element {
        const { sortedBreadcrumbs } = this.props
        const { show } = this.state

        const numberOfBreadcrumbs = sortedBreadcrumbs.length

        return (
            <>
                <Action
                    id="hierarchyButton"
                    onClick={this.showModal}
                    extraClasses="tw-mr-1"
                    isLabel={true}
                >
                    {Symbols.HierarchicalView}
                </Action>
                <Modal
                    isShown={show}
                    containerProps={{
                        id: "hierarchyModal",
                        targetSelector: "#hierarchyButton",
                        onClose: this.hideModal,
                    }}
                >
                    <div className="bg-lightest tw-p-3">
                        {sortedBreadcrumbs.map((breadcrumb, i) => (
                            <HierarchyItem
                                breadcrumbInfo={breadcrumb}
                                key={i}
                                level={i}
                                data-ft-current-item={
                                    i === numberOfBreadcrumbs - 1
                                }
                                data-ft-last-parent-item={i === 0}
                                data-ft-first-parent-item={
                                    i === numberOfBreadcrumbs - 2
                                }
                            />
                        ))}
                    </div>
                </Modal>
            </>
        )
    }

    showModal = (): void => this.setState({ show: true })

    hideModal = (): void => this.setState({ show: false })
}
